import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import './Bonafide.css'
import IdDoc from './IdDoc';
import AlertMessage from '../../AlertMessage';
import CloseIcon from '@mui/icons-material/Close';

const IdCard = () => {
  const [formData, setFormData] = useState({
    stdName: '',
    stdMother: '',
    religion: '',  
    class: '',
    educationalYear: '',
    dob: '',
    birthPlace: '',
    registerno: '',
    reason: '',
    selectedBookNo: '',
    schoolName: "",
    udiseNumber: "",
    password: "",
    mobileNumber: "",
    language: "",
    telephoneNumber: "",
    address: "",
    taluka: "",
    jilha: "",
    email: "",
    generalRegisterNumber: "",
    boardName: "",
    indexNumber: "",
    sanlagnataKramank: "",
    manyataKramank: "",
    schoolLogo: "",
    stdPhoto: "",
    address: ""
  });

  const [udiseNumber, setUdiseNumber] = useState('');
  // const [walletPoints, setWalletPoints] = useState(0);
  const [language, setLanguage] = useState(localStorage.getItem("language") || "English");
  const [submitted, setSubmitted] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [duplicateStudents, setDuplicateStudents] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [classes, setClasses] = useState([]);
    const [divisions, setDivisions] = useState({}); // To hold divisions for each class
  const [selectedClass, setSelectedClass] = useState('');
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
      if (alertMessage) {
        setShowAlert(true);
        const timeoutId = setTimeout(() => {
          setShowAlert(false);
          setAlertMessage(""); 
        }, 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [alertMessage]);

  const romanToInt = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };
  
  const marathiToInt = {
    'पहिली': 1,
    'दुसरी': 2,
    'तिसरी': 3,
    'चौथी': 4,
    'पाचवी': 5,
    'सहावी': 6,
    'सातवी': 7,
    'आठवी': 8,
    'नववी': 9,
    'दहावी': 10,
    'अकरावी':11,
    'बारावी': 12
  };



  useEffect(() => {
    const storedLanguage = localStorage.getItem("language") || "English";
    setLanguage(storedLanguage);
  }, []);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);


  useEffect(() => {
    setFormData({
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      registerno: '',
      reason: language === "English" ? "To avail of travel benefits" : "प्रवासाचे फायदे मिळावेत",
      selectedBookNo: '',
      division: '',
      stdPhoto: '',
    });
  }, [language]);

  const fetchClassDivData = async () => {
      try {
        const storedDivClasses = localStorage.getItem("classDiv");
        if (storedDivClasses) {
          const data = JSON.parse(storedDivClasses);
          
          const classList = [];
          const divisionList = {};
    
          for (const [className, value] of Object.entries(data)) {
            if (value === true) {
              // Class without divisions
              classList.push(className);
              divisionList[className] = []; // Initialize with an empty array
            } else if (typeof value === 'object') {
              // Class with divisions
              classList.push(className);
              divisionList[className] = Object.keys(value).filter(div => value[div]); // Get divisions that are true
            }
          }
    
          setClasses(classList);
          setDivisions(divisionList); // Set the divisionList as the state
        }
      } catch (error) {
        console.error("Error fetching classDiv data: ", error);
      }
    };
    // const allDivisions = Object.values(divisions).flat();
  
    useEffect(() => {
      fetchClassDivData();
    }, [udiseNumber]);
  
    const openIndexedDB = () => {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open('SchoolManagementDB', 1); 
  
        request.onerror = (event) => {
          console.error("IndexedDB error:", event.target.error);
          reject("Error opening IndexedDB");
        };
  
        request.onsuccess = (event) => {
          resolve(event.target.result);
        };
  
        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          if (!db.objectStoreNames.contains('studentData')) {
            db.createObjectStore('studentData', { keyPath: 'id' });
          }
         
        };
      });
    };


 const handleSelectStudent = (selectedStudents) => {
  if (Array.isArray(selectedStudents) && selectedStudents.length > 0) {
    // Update selected students state
    setSelectedStudents(selectedStudents);

    // Prepare updated form data
    const updatedFormData = {
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      dobInWords: '',
      studentId: '',
      stdSurname: '',
      stdFather: '',
      stdAdharNo: '',
      division: '',
      stdPhoto: '',
    };

    // Combine data from all selected students into the updatedFormData
    selectedStudents.forEach((student, index) => {
      updatedFormData.stdName += (index > 0 ? ", " : "") + (student.stdName || '');
      updatedFormData.stdMother += (index > 0 ? ", " : "") + (student.stdMother || '');
      updatedFormData.religion += (index > 0 ? ", " : "") + (student.religion || '');
      updatedFormData.class += (index > 0 ? ", " : "") + (student.currentClass || '');
      updatedFormData.educationalYear += (index > 0 ? ", " : "") + (student.educationalYear || '');
      updatedFormData.dob += (index > 0 ? ", " : "") + (student.dob || '');
      updatedFormData.birthPlace += (index > 0 ? ", " : "") + (student.birthPlace || '');
      updatedFormData.dobInWords += (index > 0 ? ", " : "") + (student.dobInWords || '');
      updatedFormData.studentId += (index > 0 ? ", " : "") + (student.studentId || '');
      updatedFormData.stdSurname += (index > 0 ? ", " : "") + (student.stdSurname || '');
      updatedFormData.stdFather += (index > 0 ? ", " : "") + (student.stdFather || '');
      updatedFormData.stdAdharNo += (index > 0 ? ", " : "") + (student.stdAdharNo || '');
      updatedFormData.division += (index > 0 ? ", " : "") + (student.division || '');
      updatedFormData.stdPhoto += (index > 0 ? ", " : "") + (student.stdPhoto || '');

    });

    // Update form data state
    setFormData((prevData) => ({
      ...prevData,
      ...updatedFormData,
    }));
  } else {
    console.error('Invalid input: selectedStudents should be a non-empty array');
  }
};

  const handleChange = async (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  
    if (name === 'class') {
      setSelectedClass(value);
      setDuplicateStudents([]);
      setShowDuplicatePopup(false);
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const request = objectStore.getAll(); // Fetch all records
  
        request.onsuccess = (event) => {
          const data = event.target.result;
  
        // Filter out null values
        // data = Object.values(data).filter(student => student !== null);
  
            // Filter out inactive students
            const activeStudents = data.filter(student => student.isActive !== false);

            const matchingStudents = activeStudents.filter((student) => student.currentClass === value);
            
        if (matchingStudents.length > 0) {
          setDuplicateStudents(matchingStudents);
          setShowDuplicatePopup(true);
        } else {
          setFormData((prevData) => ({
            ...prevData,
            stdName: '',
            stdMother: '',
            religion: '',
            class: '',
            educationalYear: '',
            dob: '',
            birthPlace: '',
            dobInWords: '',
            studentId: '',
            stdSurname: '',
            stdFather: '',
            stdAdharNo: '',
            division: '',
            stdPhoto: '',
          }));
        }
      }
      request.onerror = (event) => {
        console.error("Error fetching data from IndexedDB:", event.target.error);
      };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const handleReset = () => {
    setFormData({
      stdName: '',
      stdMother: '',
      religion: '',
      class: '',
      educationalYear: '',
      dob: '',
      birthPlace: '',
      registerno: '',
      reason: '',
      selectedBookNo: '',
      division: '',
      stdPhoto: '',
    });
    setSubmitted(false);
    window.location.reload();
  };

  const DuplicateStudentPopup = ({ duplicateStudents, onSelectStudent, onClose  }) => {
    const [selectedStudents, setSelectedStudents] = useState([]);
  
    const handleCheckboxChange = (student) => {
      const updatedSelectedStudents = selectedStudents.includes(student)
        ? selectedStudents.filter((s) => s !== student)
        : [...selectedStudents, student];
  
      setSelectedStudents(updatedSelectedStudents);
    };
  
    const handleSelectAllChange = (event) => {
      if (event.target.checked) {
        setSelectedStudents(duplicateStudents);
      } else {
        setSelectedStudents([]);
      }
    };

    const handleConfirmSelection = () => {
      if (selectedStudents.length > 0) {
        onSelectStudent(selectedStudents);
      }
      onClose(); // Close the popup after selection
    };
  
    const isAllSelected = selectedStudents.length === duplicateStudents.length;
    return (
      <div className="popup" style={{ position: 'relative' }}>
        <button onClick={onClose}  style={{ position: 'absolute', top: '10px', right: '2px', background: 'red', borderRadius: '50%', color: 'white', cursor: 'pointer', zIndex: 1, padding:'1px'  }}><CloseIcon /></button>
        
        <h3 style={{ color: 'rgb(27, 67, 50)', fontWeight: '600', marginBottom: '20px', borderBottom: '1px solid rgb(27, 67, 50)' }}>Select Students</h3>
        
        <div style={{ display: 'inline-flex' }}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSelectAllChange} style={{ height: '14px', marginRight: '10px', width: 'auto', marginTop: '4px' }}
          />
          <label style={{ fontSize: '15px', textAlign: 'left' }}>Select All </label>
        </div>
  
        <ul className="student-list">
          {duplicateStudents.map((student, index) => (
            <li key={index} className="student-item" style={{ display: 'flex' }}>
              <input 
                type="checkbox"
                checked={selectedStudents.includes(student)}
                onChange={() => handleCheckboxChange(student)}
                style={{ height: '14px', marginRight: '10px', width: 'auto', marginTop: '4px' }}
              />
              <label style={{ fontSize: '13px', textAlign: 'left' }}>
                {student.stdName} {student.stdFather} {student.stdSurname}
              </label>
            </li>
          ))}
        </ul>
        <button className="confirm-button" onClick={handleConfirmSelection}>Confirm</button>
        <style jsx>{`
          .popup {
            background-color: white;
            border: 1px solid #ccc;
            border-radius: 10px;
            padding: 20px;
            width: 90%;
            max-width: 500px;
            margin: 20px auto;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease-in-out;
          }
          h3 {
            font-size: 24px;
            margin-bottom: 10px;
            text-align: center;
          }
  
          .student-list {
            max-height: 200px;
            overflow-y: auto;
            margin-bottom: 10px;
            transition: max-height 0.3s ease;
          }
  
          .student-item {
            padding: 10px;
            border-bottom: 1px solid #ddd;
            transition: background-color 0.2s ease, transform 0.2s ease;
          }
  
          .student-item:hover {
            background-color: #f9f9f9;
            transform: translateX(5px);
          }
  
          .confirm-button {
            display: block;
            width: 100%;
            padding: 10px;
            background-color: #8A1538;
            color: white;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }
  
          .confirm-button:hover {
            background-color: #0056b3;
          }
  
          @media (max-width: 600px) {
            .popup {
              width: 90%;
              padding: 10px;
            }
            h3 {
              font-size: 18px;
            }
  
            .student-list {
              max-height: 150px;
            }
  
            .student-item {
              padding: 8px;
            }
  
            .confirm-button {
              padding: 8px;
            }
          }
        `}</style>
      </div>
    );
  };
return (
<div className="home">
    
 <AlertMessage message={alertMessage} show={showAlert}/>
      {showDuplicatePopup && (
        <div className="popup-container">
        
          <div className="popup">
          
            <DuplicateStudentPopup
              duplicateStudents={duplicateStudents}
              onSelectStudent={handleSelectStudent}
              onClose={() => setShowDuplicatePopup(false)} 
            />
          </div>
        </div>
      )}

  <div className="id-container" style={{ float:'left', left:'0'}}>
    <h3  className='text-center mb-5' style={{ color: '#1B4332', fontWeight: '600' }}>{language === "English" ? "Identity Card" : "ओळख पत्र"}</h3>
    <div className="form-output">
      <form>  
 
       <div style={{marginLeft:'5px'}}>
              <label>{language === "English" ? "Class" : "वर्ग"}:-</label>
              <select style={{ width: '300px',height:'45px', padding:'10px'}} name="class" value={formData.class} onChange={handleChange}>
                <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
                {classes
    .sort((a, b) => {
      const classA = a.split(' ')[1];
      const classB = b.split(' ')[1];
      let numA, numB;

      if (language === "English") {
        numA = romanToInt[classA] !== undefined ? romanToInt[classA] : 0; // Default to 0 if not found
        numB = romanToInt[classB] !== undefined ? romanToInt[classB] : 0; // Default to 0 if not found
      } else {
        numA = marathiToInt[classA] !== undefined ? marathiToInt[classA] : 0; // Default to 0 if not found
        numB = marathiToInt[classB] !== undefined ? marathiToInt[classB] : 0; // Default to 0 if not found
      }

      return numA - numB; // Sort based on the numerical value
    })
    .map((cls, index) => (
      <option key={index} value={cls}>
        {cls}
      </option>
    ))}
              </select>
       </div>
    
        <br/>
        <div className="form-buttons" style={{ float:'right', right:'0' }}>
          <button className="reset-btn" type="button" onClick={handleReset} style={{ marginLeft: '30px', marginTop:'-9px', padding:'8px 10px' }}>{language === "English" ? "Reset" : "रीसेट करा"}</button>
          
        </div>
       
        <div>
       
      </div>

      </form>       
    </div>  
  </div>
  <div style={{width:'70%'}}>
      <IdDoc 
        submitted={submitted}
        handleSelectStudent={handleSelectStudent}
        formData={formData}
        selectedStudents={selectedStudents}
      />
   </div>
    </div>
  );
};

export default IdCard;
